import { SplitCalculatorConfiguration } from 'features/unifiedFlow/api'

import { TemplateInfoWithInternalId } from '../addedTemplates/AddedComponentList'

import Fixed from './versions/Fixed'
import MetricSelection from './versions/MetricSelection'
import Standard from './versions/Standard'
import VariantDropdown from './versions/VariantDropdown'

type Props = {
  template: TemplateInfoWithInternalId
  configuration: SplitCalculatorConfiguration['splitCalculation']
}

const SplitCalculator = ({ template, configuration }: Props) => {
  switch (configuration.type) {
    case 'metric_selection':
      return (
        <MetricSelection template={template} configuration={configuration} />
      )
    case 'standard':
      return <Standard template={template} configuration={configuration} />
    case 'fixed':
      return <Fixed template={template} configuration={configuration} />
    default:
      return <VariantDropdown template={template} />
  }
}

export default SplitCalculator
